import { createFileRoute, useParams } from "@tanstack/react-router";
import { requireFeature } from "@/lib/feature-gate";
import { TaskDetailPage } from "@/components/task/TaskDetailPage";

export const Route = createFileRoute("/user/_layout/my-tasks_/$id")({
  beforeLoad: () => requireFeature("tasks"),
  component: MyTaskDetail,
});

function MyTaskDetail() {
  const { id } = useParams({ from: "/user/_layout/my-tasks_/$id" });
  return (
    <TaskDetailPage
      taskId={Number(id)}
      isAdmin={false}
      isCrm={false}
      backTo="/user/my-tasks"
      
    />
  );
}
